import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  text = 'Chargement...',
  className = ''
}) => {
  const sizeClasses = {
    small: 'size-4 border-2',
    medium: 'size-8 border-[3px]',
    large: 'size-11 border-[3px]'
  };

  return (
    <div className={`flex flex-1 flex-col items-center justify-center gap-3 p-8 ${className}`}>
      <div className={`animate-spin rounded-full border-slate-200 border-t-dca-blue ${sizeClasses[size]}`}></div>
      {text && (
        <p className="font-Nunito text-sm font-medium text-slate-500">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
